import { getCountryUrl, getRegionUrl } from '@domain/routes/urls';

interface IProps {
  regionId?: string | null;
  regionName?: string | null;
  regionDisplayName?: string | null;
  countryId?: string;
  countryName?: string;
  countyName?: string;
}

/**
 * `getLocationLinksString` returns a string with links to a region and country based on provided IDs and names.
 * It is mainly used in metadata.
 *
 * @param {Object} props - The properties object.
 * @param {string | null} [props.regionId] - The ID of the region (optional).
 * @param {string | null} [props.regionName] - The name of the region (optional).
 * @param {string} props.countryId - The ID of the country.
 * @param {string} props.countryName - The name of the country.
 *
 * @returns {JSX.Element} The rendered `LocationLinks` component.
 */
export const getLocationLinksString = ({
  regionId,
  regionName,
  regionDisplayName,
  countryId,
  countryName,
  countyName,
}: IProps) => {
  const displayName = regionDisplayName ?? regionName;
  return countryId
    ? // nosemgrep: javascript.lang.security.html-in-template-string
      `${countyName ? `${countyName}, ` : ''}${countryId && regionId && `<a href="${getRegionUrl(countryId, regionId, countryName ?? '', regionName ?? '')}">${displayName}</a>, `}
    <a href="${getCountryUrl(countryId, countryName ?? '')}">${countryName}</a>`
    : '';
};
